import React from "react";
import {Row, Col, Button, Radio} from "antd";
import { formatMoneyValue, formatMoney, formatExchangeRate } from "utils/utils";
import { getPurposeOfTransferByCode } from "domain/PurposeOfTransfer";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import { getCurrentCustomer } from "api/api";
import "./ConfirmPaymentTab.scss";
import { displayGenericError } from "common/notifications";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import Divider from "antd/es/divider";
import {displayNumberWithComma} from "../../utils/utils";

class ConfirmPaymentTab extends React.Component {
  state = {
    accountStatus: null,
    isLoading: false
  };

  refreshCurrentCustomer = () => {
    this.setState({
      isLoading: true
    });
    getCurrentCustomer()
      .then(response => {
        this.setState({
          isLoading: false,
          accountStatus: response.status
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          accountStatus: null
        });
        displayGenericError(error);
      });
  };

  componentDidMount() {
    this.refreshCurrentCustomer();
  }

  render() {
    const intl = this.props.useIntl;

    let beneVa = null;
    let location = '';
    let balanceStr = '';

    return (
      <>
        <h4 className="bp-page-headline"><FormattedMessage id="app.panel.confirmpaymenttab.ordersummary"/></h4>

        <div className="bp-page-body confirm-tab">
          <h3 className="bp-small-heading">
            <FormattedMessage id="app.panel.confirmpaymenttab.amountdetails"/>
          </h3>

          <div className="bp-bordered-panel bp-margin-top-smallest">
            <Row className="bp-row" gutter={16}>
              <Col lg={5} md={8} xs={13}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.sendamount"})}
                  value={formatMoneyValue(this.props.payment.sourceValue)}
                />
              </Col>
              <Col lg={5} md={8} xs={11}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.remittancefees"})}
                  value={
                    formatMoney(this.props.payment.fee) +
                    " " +
                    this.props.payment.sourceValue.currency
                  }
                />
              </Col>
              <Col lg={5} md={8} xs={13}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.amountconverted"})}
                  value={
                    formatMoney(this.props.payment.convertedAmount) +
                    " " +
                    this.props.payment.sourceValue.currency
                  }
                />
              </Col>
              <Col lg={4} md={8} xs={11}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.exchangerate"})}
                  value={formatExchangeRate(
                    this.props.exchangeRate.exchangeRate
                  )}
                />
              </Col>
              <Col lg={5} md={8} xs={24}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.beneficiarygets"})}
                  value={formatMoneyValue(this.props.payment.targetValue)}
                />
              </Col>
            </Row>
          </div>

          {/*customer section*/}
          {this.buildOriginatorInfo()}


          <h3 className="bp-small-heading bp-margin-top-small">
            <FormattedMessage id="app.panel.confirmpaymenttab.beneficiarydetails"/>
          </h3>
          <div className="bp-bordered-panel bp-margin-top-smallest">
            <Row className="bp-row" gutter={16}>
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.nameofbeneficiary"})}
                  value={this.props.beneficiary.fullName}
                />
              </Col>
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.bankaccount"})}
                  value={this.props.beneficiary.accountNumber}
                />
              </Col>
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.bankcountry"})}
                  value={this.props.beneficiary.bankCountryName}
                />
              </Col>
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.bankname"})}
                  value={this.props.beneficiary.bankName}
                />
              </Col>
            </Row>

            {beneVa&& (
                <>
                  <Divider />
                <Row gutter={16}>
                  <Col sm={6}>
                    <FieldValueVerticalCell title={'VA Location'} value={location}/>
                  </Col>
                  <Col sm={6}>
                    <FieldValueVerticalCell title={'VA Balance'} value={balanceStr}/>
                  </Col>
                  <Col sm={6}>
                    <FieldValueVerticalCell title={'VA Name'} value={beneVa.virtualAccountName}/>
                  </Col>
                  <Col sm={6}>
                    <FieldValueVerticalCell title={'VA No'} value={beneVa.virtualAccountNumber}/>
                  </Col>
                </Row>
                </>
            )}
          </div>

          <h3 className="bp-small-heading bp-margin-top-small">
          <FormattedMessage id="app.panel.confirmpaymenttab.orderinformation"/>
          </h3>
          <div className="bp-bordered-panel bp-margin-top-smallest">
            <Row className="bp-row" gutter={16}>
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.purposeoftransfer"})}
                  value={getPurposeOfTransferByCode(
                    this.props.purposeOfTransfer
                  )}
                />
              </Col>
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.messagetobeneficiary"})}
                  value={this.props.noteToBeneficiaryText}
                />
              </Col>
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.confirmpaymenttab.reference"})}
                  value={this.props.referenceText}
                />
              </Col>
              {/*
              <Col sm={6}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title="Invoice"
                  value={this.props.invoiceFileName || "-"}
                />
              </Col>
              */}
            </Row>
          </div>
        </div>

        <div className="bp-padded-top-panel bp-buttons-panel">
          <Button
            size="large"
            className="bt-skip btn-wide-md"
            onClick={this.props.onBack}
          >
            <FormattedMessage id="app.panel.confirmpaymenttab.back"/>
          </Button>
          {/* {this.state.accountStatus === "PENDING" && ( 
            <Button
              type="primary"
              size="large"
              className="btn-wide-md"
              onClick={() => this.props.onCompleted()}
            >
              Save as draft
            </Button>
           )} */}
          <Button
            type="primary"
            size="large"
            className="btn-wide-md"
            onClick={this.props.handleMakePayment}
          >
            <FormattedMessage id="app.panel.confirmpaymenttab.confirm"/>
          </Button>
        </div>
      </>
    );
  }

  buildOriginatorInfo() {
    const intl = this.props.useIntl;
    let originatorVA = null;
    let originator = this.props.originator;
    if(originator && originator.virtualAccounts && originator.virtualAccounts.length>0) {
      originatorVA = originator.virtualAccounts.find(item => item.id === this.props.selectedOriginatorVAId);
    }
    let location = '';
    let balanceStr = '';
    if(originatorVA) {
      if (originatorVA.virtualAccountChannelCode == 'DBS_HK') {
        location = "Hong Kong"
      } else if (originatorVA.virtualAccountChannelCode == 'DBS_SG') {
        location = "Singapore"
      } else if (originatorVA.virtualAccountChannelCode == 'SAHABAT_SAMPOERNA') {
        location = "Indonesia"
      } else if (originatorVA.virtualAccountChannelCode == 'FLASH_FX') {
        location = "Australia"
      }

      if (originatorVA.vaBalanceStrClaimed) {
        let result = '';
        if(this.props.payment.sourceValue.currency in originatorVA.vaBalanceStrClaimed) {
          result = this.props.payment.sourceValue.currency + " " + displayNumberWithComma(originatorVA.vaBalanceStrClaimed[this.props.payment.sourceValue.currency]);

          if (result.length == 0) {
            result = intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance.empty"});
          }
        }
        balanceStr = result;

        // let balanceArray = originatorVA.vaBalanceStr.split(',');
        // for (var i = 0; i < balanceArray.length; i++) {
        //   if (balanceArray[i].includes(this.props.payment.targetValue.currency)) {
        //     balanceStr = balanceArray[i];
        //     break;
        //   }
        // }
      }
    }

    if (originator) {
      return (
          <>
            <h3 className="bp-small-heading bp-margin-top-small">
              <FormattedMessage id="app.panel.confirmpaymenttab.senderdetails"/>
            </h3>
            <div className="bp-bordered-panel bp-margin-top-smallest">
              <Row className="bp-row" gutter={16}>
                <Col sm={6}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title={intl.formatMessage({id: "app.panel.confirmpaymenttab.sendername"})}
                      value={originator.displayName}
                  />
                </Col>
                <Col sm={6}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title={intl.formatMessage({id: "app.panel.confirmpaymenttab.sendertype"})}
                      value={originator.originatorType}
                  />
                </Col>
                <Col sm={6}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title={intl.formatMessage({id: "app.panel.confirmpaymenttab.sourceoffunds"})}
                      value={originator.sourceOfFunds}
                  />
                </Col>
                <Col sm={6}>
                  <FieldValueVerticalCell
                      className="bp-table-cell"
                      title={intl.formatMessage({id: "app.panel.confirmpaymenttab.referencenumber"})}
                      value={originator.referenceNumber}
                  />
                </Col>

              </Row>

            {originatorVA && (
                <>
                  <Divider />
                  <Row gutter={16}>
                    <Col sm={6}>
                      <FieldValueVerticalCell
                          className="bp-table-cell"
                          title={intl.formatMessage({id: "app.panel.originatordetailspanel.valocation"})} value={location}/>
                    </Col>
                    <Col sm={6}>
                      <FieldValueVerticalCell
                          className="bp-table-cell"
                          title={intl.formatMessage({id: "app.page.dashboardrxpage.claimedbalance"})} value={balanceStr}/>
                    </Col>
                    <Col sm={6}>
                      <FieldValueVerticalCell
                          className="bp-table-cell"
                          title={intl.formatMessage({id: "app.panel.originatordetailspanel.vaname"})} value={originatorVA.virtualAccountName}/>
                    </Col>
                    <Col sm={6}>
                      <FieldValueVerticalCell
                          className="bp-table-cell"
                          title={intl.formatMessage({id: "app.panel.originatordetailspanel.vanumber"})} value={originatorVA.virtualAccountNumber}/>
                    </Col>
                  </Row>
                </>
            )}
                </div>
          </>
      )
    }
    ;
  }
}

export default withUseIntl(ConfirmPaymentTab);